module.exports = __webpack_public_path__ + "static/media/sanmeet.ba9988d5.jpg";